import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { Context } from '@nuxt/types'

export default (context: Context) => {
  const { $config, env } = context
  const environment = $config.env || 'dev'
  const release = $config.sentryRelease
  Sentry.init({
    Vue,
    dsn: $config.sentryDsn || process.env.SENTRY_DSN,
    environment,
    integrations: [
      new Sentry.BrowserTracing(),
      new Sentry.Replay({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // パフォーマンスモニタリングのサンプルレート（stgの場合は100%、それ以外は10%）
    tracesSampleRate: environment === 'stg' ? 1.0 : 0.1,
    // リリースバージョンを設定（ビルド時の環境変数と一致させる）
    release,
    // エラーフィルタリング
    beforeSend(event) {
      return event
    },
  })

  const user = context.store?.state?.auth?.user
  if (user) {
    Sentry.setUser({
      id: user.uid,
      email: user.email,
    })
  }
}
